export const BxSuperscript = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.18874 6.60465H5.50324L7.94687 10.2639L10.4203 6.60465L12.5957 6.65318L9.00976 11.6713L12.7547 17H10.47L7.82767 13.0981L5.26483 17H3L6.74492 11.6713L3.18874 6.60465Z"
        fill="#666C7A"
      />
      <path
        d="M15.7149 4.09923C15.5882 3.95121 15.4069 3.8772 15.171 3.8772C14.8482 3.8772 14.6284 3.99489 14.5117 4.23026C14.4446 4.36615 14.4049 4.58211 14.3925 4.87815H13.3606C13.378 4.42924 13.4612 4.06647 13.6102 3.78984C13.8933 3.26328 14.3962 3 15.1188 3C15.69 3 16.1445 3.1553 16.4822 3.4659C16.82 3.77407 16.9888 4.18294 16.9888 4.69252C16.9888 5.0832 16.8696 5.43019 16.6312 5.73351C16.4748 5.93492 16.2177 6.15937 15.8601 6.40688L15.4355 6.70171C15.1698 6.88613 14.9872 7.01959 14.8879 7.10209C14.791 7.18459 14.7091 7.28044 14.642 7.38964H17V8.30323H13.301C13.311 7.92469 13.3941 7.57891 13.5506 7.26588C13.7021 6.91403 14.0597 6.54155 14.6234 6.14845C15.1126 5.80631 15.4293 5.56123 15.5733 5.41321C15.7943 5.18268 15.9048 4.93032 15.9048 4.65612C15.9048 4.43288 15.8415 4.24725 15.7149 4.09923Z"
        fill="#666C7A"
      />
    </svg>
  )
}
